var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSharedFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.001,
    viewBox: "0 0 20 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_1",
    "data-name": "Differenzmenge 1",
    d: "M-5320-98h-16a2,2,0,0,1-2-2l.009-12a2,2,0,0,1,1.99-2h6l2,2h8a2,2,0,0,1,2,2v10A2,2,0,0,1-5320-98Zm-9.628-6h0l2.927,1.794a1.244,1.244,0,0,0-.032.28,1.232,1.232,0,0,0,1.2,1.26,1.233,1.233,0,0,0,1.2-1.26,1.233,1.233,0,0,0-1.2-1.26,1.155,1.155,0,0,0-.8.333l-2.936-1.789a1.483,1.483,0,0,0,.038-.3,1.49,1.49,0,0,0-.038-.3l2.9-1.771a1.208,1.208,0,0,0,.838.35,1.268,1.268,0,0,0,1.236-1.294,1.268,1.268,0,0,0-1.236-1.294,1.267,1.267,0,0,0-1.233,1.294,1.451,1.451,0,0,0,.037.3l-2.9,1.774a1.2,1.2,0,0,0-.841-.35,1.267,1.267,0,0,0-1.233,1.294,1.265,1.265,0,0,0,1.233,1.292,1.2,1.2,0,0,0,.84-.349Z",
    transform: "translate(5338 114.001)",
    fill: "#006b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharedFolder);
export default __webpack_public_path__ + "static/media/Icon_SharedFolder.1332e5e59f4cf4855215d6326de6b45a.svg";
export { ForwardRef as ReactComponent };